import TextField from '@mui/material/TextField'

const CustomTextField = ({ label, value, valid, validate, required, helperText, onChange, style, multiline }) => {
  return (
    <div className="mb-5">

      <TextField
        required={required}
        error={!valid}
        helperText={helperText}
        placeholder={label}
        label={label}
        value={value}
        onBlur={validate}
        onChange={e => onChange(e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
        type="search"
        style={style}
        multiline={multiline}
        minRows={1}
        maxRows={multiline ? 5 : 1}
        fullWidth
      />
    </div>
  )
}

export default CustomTextField